<template>
  <div>
    <v-row v-if="!no_title" class="flex">
      <v-col :md="title_md">
        <h2 class="tableTitle">
          <slot name="crud-title"></slot>
        </h2>
      </v-col>
      <v-col :md="sc_btns_md" class="sc-btns">
        <slot name="btns">
          <slot name="extra-btns"></slot>
          <slot name="add-btn">
            <v-btn color="primary" @click="newItem" small  v-if="canAdd"><!-- class="btn-radius" outlined -->
              <v-icon>add</v-icon>
              <span>Agregar</span>
            </v-btn>
          </slot>
        </slot>
      </v-col>
    </v-row>

    <v-data-table
      :hide-default-footer="computedRows.length<10"
      :disable-pagination="computedRows.length<10"
      disable-sort
			:headers="headers"
			:items="computedRows"
			class="tablaLT1 p-flex"
      :item-key="item_key"
			:expanded.sync="expanded"
			:show-expand="expandable"
			:class="dark_t?'dark':''">
      <template v-slot:body="{ items}">
        <tbody>
          <template v-for="(item,i) in items">
            <tr :key="`A-${i}`">
              <fs1 tag="td" v-if="expandable">
                <slot name="expand_icon" v-bind="{item,expanded,expand,is_expanded:is_expanded(item)}">
                  <v-icon @click="expand(item)">
                    {{is_expanded(item) ? 'expand_more': 'chevron_right'}}
                  </v-icon>
                </slot>
              </fs1>
              <template v-for="(v, h_i) in hearder_array">  
                <slot :name="v" v-bind="{value:item[v], item, items, itemDetail, writeItem, askForDelete,disabled,ask_for_toggle}">
                  <fs1 tag="td" :key="h_i" :class="headers[h_i].class||''" >				                    
                    <template v-if="v == 'actions'">
                      <template v-if="actions_expanded">
                        <v-icon class="ma-1 pointer" @click="itemDetail(item)" v-if="canDetail" :disabled="disabled('detail',item)">account_box</v-icon>
                        <v-icon class="ma-1 pointer" @click="writeItem(item)" v-if="canWrite" :disabled="disabled('edit',item)">edit</v-icon>
                        <v-icon class="ma-1 pointer" @click="askForDelete(item)" v-if="canDelete" :disabled="disabled('delete',item)">delete</v-icon>
                      </template>
                      <v-menu :close-on-click="true" :offset-y="true" v-else>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">more_vert</v-icon>
                        </template>
                        <v-list>

                          <v-list-item  @click="askForDelete(item)" v-if="canDelete" :disabled="disabled('delete',item)">
                            <v-icon>delete</v-icon>
                            <span>Eliminar</span>
                          </v-list-item>

                          <v-list-item @click="itemDetail(item)" v-if="canDetail" :disabled="disabled('detail',item)">
                            <v-icon>description</v-icon>
                            <span>Ver ficha</span>
                          </v-list-item>

                          <v-list-item @click="writeItem(item)" v-if="canWrite" :disabled="disabled('edit',item)">
                            <v-icon>edit</v-icon>
                            <span>Editar</span>
                          </v-list-item>
          <!-- agregar slots? -->
                        </v-list>
                      </v-menu>

                    </template>

                    <template v-else>
                      <a v-if="var_type(v) === 'file'" href="#" class="tableM1_file" @click.prevent="openFileField(item, v)">
                        <v-icon >insert_drive_file</v-icon>
                      </a>
                      <template v-else>{{item[v]}}</template>
                    </template>
                  </fs1>
                </slot>
              </template>
            </tr>
            <tr v-if="is_expanded(item)" :key="`B-${i}`">
              <fs1 tag="td" :colspan="hearder_array.length+1">
                <slot name="expanded" v-bind="{item}">---</slot>
              </fs1>
            </tr>
          </template>
          <tr v-if="items.length === 0">
            <fs1 tag="td" :colspan="hearder_array.length+1">
              <v-icon>warning</v-icon>
              Sin Información.
            </fs1>
          </tr>
        </tbody>
      </template>
		</v-data-table>

    <v-dialog v-model="dialogDetail" :width="rw_width">
			<v-card class="fullHeight pa-20" v-if="dialogDetail">
        <template1 :title_cols="read_title_cols">
          <template slot="title">
            <slot name="read-title" v-bind="{selectedItem}"></slot>
          </template>
          <template slot="extra">
            <v-icon class="closeDialog" v-on:click="dialogDetail = false">close</v-icon>
          </template> 
        </template1>
        <slot name="read" v-bind:selectedItem="selectedItem"></slot>
				<div style="text-align: center">
					<v-btn color="secondary" @click="dialogDetail = false" class="ma-4">
						<v-icon>close</v-icon>
						<span>Cerrar</span>
					</v-btn>
				</div>
			</v-card>
    </v-dialog>

    <v-dialog v-model="dialogWrite" :width="rw_width" persistent>
			<v-card class="fullHeight pa-20" v-if="dialogWrite">
        <template1 :title_cols="write_title_cols">
          <template slot="title">
            <slot name="write-title" v-bind="{selectedItem}"></slot>
          </template>
          <template slot="extra">
            <v-icon class="closeDialog" v-on:click="dialogWrite = false">close</v-icon>
          </template> 
        </template1>
        <slot name="write" v-bind="{save:check_and_save,selectedItem,closeDialogWrite,items:computedRows}"></slot>

				
        <slot name="write-btns" v-bind="{save:check_and_save,selectedItem,closeDialogWrite}">
          <div style="text-align: center; margin-top:30px">
            <v-btn color="secondary" @click="closeDialogWrite" class="ma-4">
              <v-icon>close</v-icon>
              <span>Cancelar</span>
            </v-btn>
            <v-btn color="primary" @click="check_and_save" class="ma-4">
              <v-icon class="mr-1">
                <slot name="write-btns-save-icon">save</slot>
              </v-icon>
              <span>
                <slot name="write-btns-save-text">Guardar</slot>
              </span>
            </v-btn>
          </div>
        </slot>
				
			</v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" :width="'50%'" persistent>
			<v-card class="fullHeight pa-20">
        <template1>
          <template slot="title">
            <slot name="delete-title" v-bind="{selectedItem}">Eliminar</slot>
          </template>
          <template slot="extra">
            <v-icon class="closeDialog" v-on:click="deleteDialog = false">close</v-icon>
          </template> 
        </template1>
        <div>
          <slot name="deleteAsk" v-bind:selectedItem="selectedItem">{{selectedItem.name||''}}</slot>
        </div>
				<div style="text-align: center; margin-top: 30px">
					<v-btn color="secondary" @click="deleteDialog = false" class="ma-4">
						<v-icon>reply</v-icon>
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary"  @click="deleteItem(selectedItem)" class="ma-4">
						<v-icon>delete</v-icon>
						<span>Aceptar</span>
					</v-btn>
				</div>
			</v-card>
    </v-dialog>

    <v-dialog v-model="toggle_dialog" :width="'50%'">
			<v-card class="fullHeight pa-20">
        <template1>
          <template slot="title">
            <slot name="toggle-title" v-bind="{selectedItem}">Eliminar</slot>
          </template>
          <template slot="extra">
            <v-icon class="closeDialog" v-on:click="toggle_dialog = false">close</v-icon>
          </template> 
        </template1>
        <div>
          <slot name="toggle-ask" v-bind:selectedItem="selectedItem">{{selectedItem.name||''}}</slot>
        </div>
				<div style="text-align: center; margin-top: 30px">
					<v-btn color="secondary" @click="toggle_dialog = false" class="ma-4">
						<v-icon>reply</v-icon>
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary"  @click="toggle_item(selectedItem,toggle_key)" class="ma-4">
						<span>Aceptar</span>
					</v-btn>
				</div>
			</v-card>
    </v-dialog>

    <v-dialog v-model="dialogCustom" :width="'50%'">
			<v-card class="fullHeight pa-20">
        <slot name="dialog-custom" ></slot>
        <slot name="dialog-custom" v-bind:slotprops="{ closeDialogCustom}"></slot>
			</v-card>
    </v-dialog>

  </div>
</template>

<script>
/*
  datos son otorgados por props a diferencia de la otra version 1(que los obtiene por request al cargar)
    -no tiene  paginacion
    -no tiene filtros
*/
import CustomCrud from '../CustomCrudV2.js';

export default {
  mixins: [ CustomCrud ],
  props:{
    actions_expanded:{default:false},
    rw_width:{default:'50%'},//dialogWriteWdith
    read_title_cols:{default:10},
    write_title_cols:{default:10},
    expandable:{default:false},
    permissions:{default:()=>{return{}}},
    conditions:{default:()=>{return{}}},
    headers:{},
    item_key:{default:'id'},
    no_title:{default:false},
    title_md:{default:5},
    sc_btns_md:{default:7},
  },
  data() {
    return {
      expanded:[],
      /* expanded_items:[], */
      gets_on_created:true,
    };
  },
  computed: {
    hearder_array () { return Object.keys(this.headers).map(i => this.headers[i].value) },
  },
  watch:{ },
  methods: {
    disabled(key,item){
      if (this.conditions[key] && this.conditions[key](item)) return true;
      if (this.permissions[key]) return !this.myPermissions.includes(this.permissions[key]);
      return false;
    },
    expand(item,pre_expand){
      if (this.is_expanded(item)) this.expanded.splice(this.expanded.indexOf(item),1);
      else {
        if (pre_expand) pre_expand(item);
        this.expanded.push(item);
      }
    },
    is_expanded(item) { return this.expanded.indexOf(item) > -1},
    openFileField(item, field) {
      if (this.$listeners && this.$listeners['open-file']) {
        this.$emit('open-file', item, field);
        return;
      }
      const href = item && item[field];
      if (href) window.open(href, '_blank', 'noopener,noreferrer');
    },
  },
};
</script>
